module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "unbind-box section-white content-padded"
  }, [_c('div', {
    staticClass: "content-center"
  }, [_c('p', [_vm._v("您尚未绑定认证服务号，无法使用该功能。")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.toBind
    }
  }, [_vm._v("去绑定")])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-eb76929a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb76929a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/base/empty/unbind.vue
// module id = 2966
// module chunks = 0